import ItemCardContentCommonWrapper from './itemCardContentCommonWrapper'

export default ItemCardContentCommonWrapper
